<script>
    import addToBasket from "../events/addToBasket.js";
    import { onMount } from "svelte";
    import { logger } from "@otto-ec/global-resources/debug";

    /**
 *
 *
 *
 *
 *
 */

    /*                */
    let { variationId, widgetAdditionalClickTracking, additionalClickTracking, trackAdd2BasketVisibility } = $props();

    const debug = logger("reco-cinema.tracking.event-emitter");

    let add2basketButtonClicked = $state(false);
    let add2BasketFeature;

    const observeButton = () => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    trackAdd2BasketVisibility();
                    observer.disconnect();
                }
            });
        });
        observer.observe(add2BasketFeature);
    };

    const add2BasketResult = () => {
        o_global.eventQBus.on("ft1.order-core.addToBasketResult", ({ variationId: variationIdResult, successful }) => {
            if (variationIdResult !== variationId) {
                return;
            }
            add2basketButtonClicked = !!successful;
            if (!successful) {
                /*                                                                                                                    */
                debug.info(`Adding variation ${variationId} to basket was unsuccessful.`);
            }
        });
    };

    onMount(() => {
        observeButton();
        add2BasketResult();
    });

    const add2basketClickListener = (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (!add2basketButtonClicked) {
            add2basketButtonClicked = true;
            addToBasket(variationId, widgetAdditionalClickTracking, additionalClickTracking);
        }
    };
</script>

<oc-button-v1
    bind:this={add2BasketFeature}
    size="50"
    type="button"
    variant={"primary"}
    icon-type-left={add2basketButtonClicked ? "check" : "basket"}
    success={add2basketButtonClicked}
    disabled={add2basketButtonClicked}
    class="reco_basketlayer_product_card__button"
    class:clicked={add2basketButtonClicked}
    onclick={add2basketClickListener}
    data-testid={`add_to_basket_button`}
>
    <span>{add2basketButtonClicked ? "Hinzugefügt" : "Hinzufügen"}</span>
</oc-button-v1>

<style>
    .reco_basketlayer_product_card__button {
        pointer-events: all;
        z-index: 2;
    }
</style>
